import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import NotificationsListLayer from "../components/NotificationsListLayer";

const NotificationPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Notifications" />

        {/* NotificationsListLayer */}
        <NotificationsListLayer />
      </MasterLayout>
    </>
  );
};

export default NotificationPage;
